var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    { attrs: { model: _vm.form, rules: _vm.rules } },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("general.oldPassword"),
            prop: "oldPassword",
            "label-position": "top",
          },
        },
        [
          _c("el-input", {
            attrs: { type: "password" },
            model: {
              value: _vm.form.oldPassword,
              callback: function ($$v) {
                _vm.$set(_vm.form, "oldPassword", $$v)
              },
              expression: "form.oldPassword",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("general.newPassword"),
            prop: "newPassword",
            "label-position": "top",
          },
        },
        [
          _c("el-input", {
            attrs: { type: "password" },
            model: {
              value: _vm.form.newPassword,
              callback: function ($$v) {
                _vm.$set(_vm.form, "newPassword", $$v)
              },
              expression: "form.newPassword",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("general.confirmNewPassword"),
            prop: "confirmNewPassword",
            "label-position": "top",
          },
        },
        [
          _c("el-input", {
            attrs: { type: "password" },
            model: {
              value: _vm.form.confirmNewPassword,
              callback: function ($$v) {
                _vm.$set(_vm.form, "confirmNewPassword", $$v)
              },
              expression: "form.confirmNewPassword",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "el-button", on: { click: _vm.handleSubmit } },
        [_vm._v("\n    " + _vm._s(_vm.$t("Submit")) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }